module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_hair_makeup@3x-529123d5e3d4cfe3e6327e04cd68dd92.webp";